module.exports = __webpack_public_path__ + "img/four3Red.99cefe7a.jpg";